import { MetricTemplate } from '@griply/types';
import { useMemo } from 'react';

export const useMetricTemplates = (data: MetricTemplate[] | undefined) =>
  useMemo(() => data ?? [], [data]);
